export default "__VITE_ASSET__Ds8shc3O__"